module.exports = __webpack_public_path__ + "static/environment-light-vs-dark-0f0593047e4e70e86a3078980d006229.png";